import dayjs from "dayjs";

export const isPastVisit = (
  visit: { plannedStart?: { iso: string } | null },
  currentTime = dayjs()
) => {
  return currentTime.isAfter(dayjs(visit.plannedStart?.iso).add(2, "hours"));
};
